export const shouldDisplayField = (fieldsArray = [], field = "") => {
  const result = fieldsArray?.find(x => x?.name === field)
  return !!result
}

export const isRequiredField = (fieldsArray = [], field = "") => {
  const result = fieldsArray?.find(x => x?.name === field)
  return result?.required
}

export const required = value => (value ? undefined : "This field is required")

export const emailIsValid = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? "Invalid Email"
    : undefined
